import React from 'react';

const QRPreview = ({ qrCodeDataUrl, qrData, labelSize }) => {
  if (!qrCodeDataUrl) {
    return (
      <div className="qr-code-preview">
        <p>La vista previa del código QR aparecerá aquí</p>
      </div>
    );
  }

  const getClassName = () => {
    const classes = ['qr-code-preview', 'print-section'];
    if (labelSize === 'large') classes.push('large-label');
    if (labelSize === 'small') classes.push('small-label');
    return classes.join(' ');
  };

  return (
    <div className={getClassName()}>
      <div className="qr-code-image">
        <img src={qrCodeDataUrl} alt="Código QR generado" />
      </div>
      
      {qrData && (
        <div className="qr-code-data">
          <p>{qrData}</p>
        </div>
      )}
      
      <div className="button-group">
        <button className="button" onClick={() => window.print()}>
          <span role="img" aria-label="Imprimir">🖨️</span> Imprimir Etiqueta
        </button>
      </div>
    </div>
  );
};

export default QRPreview;